module.exports = __webpack_public_path__ + "static/media/73_tn.5e83bfbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/73_tn.jpg
// module id = 559
// module chunks = 0